<script setup lang="ts">
import {Icon} from '@iconify/vue';

const isOpen = defineModel<boolean>('isOpen', {default: true, type: Boolean});


const {title = '', isStatic = false, contentClass = '', icon = 'fa6-solid:chevron-down', variant = 'default', class: cssClass = ''} = defineProps<{
  title?: string;
  contentClass?: string;
  icon?: string;
  isStatic?: boolean,
  class?: string;
  variant?: 'default' | 'card' | 'flush' | 'plain' | 'static';
}>()

</script>

<template>

  <div
      class="inline-grid w-full gap-1  items-center"
      :class="[cssClass, {
      'rounded-lg border border-gray-200 bg-white': 'default' === variant || 'card' === variant,
      'rounded-xl  border border-gray-200 bg-white shadow-sm': 'card' === variant,
    }]"
  >
    <!-- Trigger button -->
    <button
        type="button"
        class="flex w-full   gap-3 items-center  text-left text-sm font-medium py-auto  text-gray-900 transition-colors"
        :class="{
        'px-3 py-3 hover:bg-gray-50': 'default' === variant,
        'px-3 py-4 hover:bg-gray-50/80': 'card' === variant,
        'px-2 py-2 hover:text-blue-600': 'flush' === variant,
        'px-1 py-1 cursor-not-allowed': isStatic
      }"
        :aria-expanded="isOpen ? 'true' : 'false'"
        @click="isStatic?isOpen = isOpen:isOpen = !isOpen"
    >
      <!-- Left: icon + header slot or title -->
      <div class="flex flex-1 gap-3 place-self-center top-0 items-center text-2xl text-gray-800   flex-nowrap flex-1 ">
        <slot name="icon">
          <Icon v-if="!isStatic && icon && 'card' != variant" :icon="icon" class="shrink-0 text-base text-gray-400"/>
        </slot>

        <slot name="header" :isOpen="isOpen">
          <template v-if="'card' === variant">
            <Icon :icon="icon" class="text-xl text-blue-600"/>

            <div class=" flex-1  flex-nowrap h-full"> {{ title }}</div>

          </template>
          <span v-else class="truncate h-full">{{ title }}</span>
        </slot>

        <!-- Right: optional badge/meta slot + chevron -->
        <div class="ml-auto flex items-center ">
          <slot name="headerRight"/>
          <Icon
              icon="fa6-solid:chevron-down"
              class="h-full text-sm text-gray-400 transition-transform duration-200"
              :class="{'rotate-180': isOpen}"
          />
        </div>
      </div>

    </button>

    <!-- Content -->

    <div
        v-show="isOpen"
        class="text-sm text-gray-600  animate-duration-800 animate-flip-down"
        :class="[contentClass, {
          'border-t border-gray-200 bg-gray-50/50 px-4 py-3': 'default' === variant,
          'border-t border-gray-200 bg-gray-50/30 px-5 py-4': 'card' === variant,
          'pt-2': 'flush' === variant,
        }]"
    >
      <slot/>
    </div>

  </div>
</template>
